import i18n from "../i18n";
import { getDataUrl } from "../config";

export async function fetchLocalizedJson<T>(
  filename: string,
  overrideLang?: string
): Promise<T> {
  const timestamp = Date.now();
  const activeLang = overrideLang || (i18n as any).language || "ja";
  const currentLang = activeLang.split("-")[0] || "ja";
  const localizedPath = filename.replace(/^\/?data\//, "");

  try {
    const langUrl = getDataUrl(`${currentLang}/${localizedPath}`);
    const res = await fetch(`${langUrl}?t=${timestamp}`);
    if (res.ok) {
      return (await res.json()) as T;
    }
  } catch {}

  if (currentLang !== "ja") {
    try {
      const jaUrl = getDataUrl(`ja/${localizedPath}`);
      const res = await fetch(`${jaUrl}?t=${timestamp}`);
      if (res.ok) {
        return (await res.json()) as T;
      }
    } catch {}
  }

  const defaultUrl = getDataUrl(localizedPath);
  const res = await fetch(`${defaultUrl}?t=${timestamp}`);
  if (res.ok) {
    return (await res.json()) as T;
  }

  throw new Error(`Failed to load data: ${filename} (status ${res.status})`);
}
